import { useCallback, useEffect, useState } from "react";
import enDayjsTranslations from "dayjs/locale/pt";
import { ParsedDatesRange } from "./utils/getDatesRange";
import {
  AllocationBlock,
  ConfigFormValues,
  SchedulerProjectData,
  SchedulerRowLabel,
} from "./types/global";

import { Scheduler } from ".";
import { useAllocation } from "./hooks/useAllocations";
import usePermission from "../hooks/usePermission";
import { useNavigate } from "react-router-dom";
import { FeatureStatic } from "../@types/statics/feature.static";

export interface IAllocation {
  data: SchedulerProjectData[];
  allocationBlocks: AllocationBlock[];
  id: string;
  label: SchedulerRowLabel;
}

function App() {
  const [values] = useState<ConfigFormValues>({
    peopleCount: 15,
    projectsPerYear: 5,
    yearsCovered: 0,
    startDate: undefined,
    maxRecordsPerPage: 3,
    isFullscreen: true,
  });
  const monthTitle = new Date().toLocaleString("pt-br", { month: "long" });

  const {
    allocations,
    isLoading,
    setRange,
  } = useAllocation();

  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.allocationMap.id);

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
  }, []);

  const handleRangeChange = useCallback((range: ParsedDatesRange) => {
    setRange(range);
  }, []);

  // Comentado para evitar chamadas duplicadas - o LeftColumn gerencia as chamadas agora
  // useEffect(() => {
  //   fetchAllocations();
  // }, [currentPage]);

  const langs = [
    {
      id: "pt",
      lang: {
        feelingEmpty: "Vazio...",
        free: "Livre",
        loadNext: "Próximo",
        loadPrevious: "Anterior",
        over: "acima",
        taken: "Ocupado",
        topbar: {
          filters: "Filtros",
          next: "Próximo",
          prev: "Anterior",
          today: `${monthTitle}`,
          view: "Visualizar",
        },
        search: "Buscar",
        week: "Semana",
      },
      translateCode: "pt-br",
      dayjsTranslations: enDayjsTranslations,
    },
  ];

  return (
    <>
      <Scheduler
        startDate={
          values.startDate
            ? new Date(values.startDate).toISOString()
            : undefined
        }
        onRangeChange={handleRangeChange}
        data={allocations}
        isLoading={isLoading}
        config={{
          showTooltip: true,
          zoom: 1,
          lang: "pt",
          translations: langs,
          maxRecordsPerPage: allocations.length,
        }}
      />
    </>
  );
}

export default App;
